import Vue from 'vue'
import '@/i18n/index'

const { i18n } = Vue

export const appointmentTableHeaders = [
  {
    text: i18n.translate('dashboard.tabFilter.tableHeaders.date'),
    value: 'date',
    align: 'center',
  },
  {
    text: i18n.translate('dashboard.tabFilter.tableHeaders.status'),
    value: 'status',
    align: 'center',
  },
  {
    text: i18n.translate('dashboard.tabFilter.tableHeaders.type'),
    value: 'type',
    align: 'center',
  },
  {
    text: i18n.translate('dashboard.tabFilter.tableHeaders.info'),
    value: 'data-table-expand',
    align: 'center',
  },
]

export const devolusPendingActionsTableHeaders = [
  {
    text: i18n.translate('devolus.table.date'),
    value: 'created_at',
    width: 140,
  },
  {
    text: i18n.translate('devolus.table.type'),
    width: 140,
    value: 'type',
  },
  {
    text: i18n.translate('devolus.table.resolution'),
    value: 'resolution_date',
    width: 140,
  },
  {
    text: i18n.translate('devolus.table.info'),
    value: 'data-table-expand',
    align: 'center',
  },
]
